<template>
  <component :is="svg" v-bind="$attrs" class="brand-flag" />
</template>

<script setup>
import { computed } from 'vue'

// Import all flags statically
import chFlag from '@/assets/img/flags/ch.svg?inline'
import deFlag from '@/assets/img/flags/de.svg?inline'
import esFlag from '@/assets/img/flags/es.svg?inline'
import frFlag from '@/assets/img/flags/fr.svg?inline'
import gbFlag from '@/assets/img/flags/gb.svg?inline'
import itFlag from '@/assets/img/flags/it.svg?inline'

// Create mapping object for flags
const FLAGS = {
  ch: chFlag,
  de: deFlag,
  es: esFlag,
  fr: frFlag,
  gb: gbFlag,
  it: itFlag,
}

defineOptions({
  name: 'Flag',
  inheritAttrs: false,
})

const props = defineProps({
  country: {
    type: String,
    required: true,
  },
})

const svg = computed(() => {
  // Use the mapping object instead of dynamic require
  if(!props.country || !FLAGS[props.country.toLowerCase()]) {
    return gbFlag
  }
  return FLAGS[props.country.toLowerCase()]
})
</script>

<style lang="scss">
.brand-flag {
  width: 32px;
  height: 24px;
  // height: 1.3em;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(black, 0.25);
}
</style>
